import { useState } from "react";
import toast from "react-hot-toast";
import { useGlobalStore } from "../../../api/globalStores";
import ButtonPrimary from "../../../Common/Buttons/ButtonPrimary";
import BaseCard from "../../../Common/Cards/BaseCard";
import Select from "../../../Common/Forms/Select";
import Modal from "../../../Common/Utility/Modal";
import { observer } from "mobx-react";
import { Class } from "../../../api/class";
import { definitions } from "../../../api/supabase/client";
import { Cron } from "react-js-cron";
import "react-js-cron/dist/styles.css";

const DEFAULT_CRON_TIME = "0 12 * * 1";
interface TimeSlotDialogProps {
  open: boolean;
  onClose: () => void;
  timeSlotId?: number | undefined;
}
export const TimeSlotDialog = observer((props: TimeSlotDialogProps) => {
  const globalStores = useGlobalStore();
  const [newTimeSlot, setNewTimeSlot] = useState<{
    classId?: number;
    cronMinHrDay?: definitions["TimeSlot"]["cronMinHrDay"];
  }>({});

  const updateTimeSlot = async () => {
    toast.promise(
      (async () => {
        if (!props.timeSlotId || !newTimeSlot.cronMinHrDay)
          throw toast.error(
            "TimeSlot ID, and class repeating timings must be specified!"
          );

        await globalStores.curClass.updateTimeSlotById(
          props.timeSlotId,
          newTimeSlot.cronMinHrDay
        );
        await globalStores.teacherStore.pullUserDetails();
        props.onClose();
      })(),
      {
        loading: "Updating Time Slot",
        success: "Time Slot Updated!",
        error: (e: any) => e.message,
      }
    );
  };

  const addTimeSlot = async () => {
    toast.promise(
      (async () => {
        if (!newTimeSlot.classId || !newTimeSlot.cronMinHrDay) {
          throw toast.error(
            "Class ID, TimeSlot ID, and class repeating timings must be specified!"
          );
        }

        const myClass = new Class();
        await myClass.init(newTimeSlot.classId);
        await myClass.addTimeSlot(newTimeSlot.cronMinHrDay);
        await globalStores.teacherStore.pullUserDetails();
        props.onClose();
      })(),
      {
        loading: "Adding Time Slot",
        success: "Time Slot Added!",
        error: (e: any) => e.message,
      }
    );
  };

  return (
    <Modal open={props.open} onClose={() => props.onClose()}>
      <BaseCard title="Create Time Slot" increaseHeight>
        <span>Note that all time slots created are in GMT+8 time</span>
        <div className="w-full inline-flex flex-col items-start gap-3">
          <Cron
            className="z-10"
            value={newTimeSlot.cronMinHrDay ?? DEFAULT_CRON_TIME}
            setValue={(val: string) => {
              setNewTimeSlot({ ...newTimeSlot, cronMinHrDay: val });
            }}
            allowedPeriods={['year', 'month', 'week', 'day', 'reboot']}
            clearButton={false}
            defaultPeriod="week"
          />
          <button className="text-sm px-3 py-2 text-brij-DarkGrey rounded-md outline outline-1 outline-brij-Grey/100" onClick={() => {
            setNewTimeSlot({ ...newTimeSlot, cronMinHrDay: DEFAULT_CRON_TIME });
          }}>
            Reset Time
          </button>
          {!props.timeSlotId && (
            <Select
              icon="badge"
              placeholder={
                typeof newTimeSlot.classId === "number"
                  ? `Class ${newTimeSlot.classId}`
                  : "Choose Class"
              }
              options={
                globalStores.teacherStore.myClasses
                  ? globalStores.teacherStore.myClasses.map((myClass) => ({
                      value: myClass.class.id!,
                      label: `Class ${myClass.class.id}`,
                    }))
                  : []
              }
              onChange={(val) =>
                setNewTimeSlot({ ...newTimeSlot, classId: +val })
              }
            />
          )}
        </div>
        <ButtonPrimary
          onClick={() => {
            if (props.timeSlotId) {
              updateTimeSlot();
            } else {
              addTimeSlot();
            }
          }}
        >
          {props.timeSlotId ? "Update" : "Create"}
        </ButtonPrimary>
      </BaseCard>
    </Modal>
  );
});
